export default {
  name: 'DocumentPreview',
  props: {
    direction: {
      type: String,
      default: 'prev',
      validator(value) {
        return ['prev', 'next'].includes(value);
      },
    },
    document: {
      type: Object,
      required: true,
    },
  },
};
